<rr-icon name="globe" class="w24 roundicon" color="nutral"></rr-icon>
<div class="col gap-8 w100" i18n>
    <h3>Would you like me to search the web for you?</h3>
    <div>Get quick answers from the web to support your idea.</div>
</div>
<div class="wrapper col w100 gap-12">
    @for(s of data; track s.source){
    <div
        class="w100 row space-between align-start queryselection"
        [ngClass]="selectedQuestion.includes(s) ? 'active' : ''"
        (click)="toggleSearch(s)"
    >
        <div class="row gap-16 align-center">
            <rr-checkbox [checked]="selectedQuestion.includes(s)"></rr-checkbox>
            <div class="col">
                <span class="strong">{{ s.title }}</span>
                <span class="tiny">Source: {{ s.source }}</span>
            </div>
        </div>
        @if(s.description){
        <rr-icon name="info" [title]="s.description"></rr-icon>
        }
    </div>
    }
</div>
<rr-disclaimer [type]="disclaimerType"></rr-disclaimer>
<div class="row gap-8 space-between align-center w100">
    <div>
        <span class="color-brand strong"
            >{{ leftSearches }} out {{ maxWebSearches }}</span
        >
        Web Searches left
    </div>
    <div class="row gap-8">
        <rr-btn type="Secondary" size="Small" (click)="close()">Cancel</rr-btn>
        <rr-btn
            type="Primary"
            size="Small"
            [disabled]="selectedQuestion.length === 0 ? true : false"
            (click)="selectedQuestion.length === 0 ? null : run()"
            >Get Web Results</rr-btn
        >
    </div>
</div>
